/**
 * Controller: MembershipCategoriesCreateModal
 */
angular.module('acme.view.application.membership.categories.createModal.controllers', [])
.controller('MembershipCategoriesCreateModalController', [ '$scope', '$uibModalInstance', 'categories', function ($scope, $uibModalInstance, categories) {

    $scope.errors = [];

    $scope.model = {
      name: '',
      description: '',
      defaultType: null,
      types: null
    };

    $scope.init = function() {

    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.trim = function(s) {
      return s.replace(/\s+/g, '').toLowerCase();
    };

    $scope.isUnique = function() {
      var i, ii,
        trimmed,
        trimmedCurrent = $scope.trim($scope.model.name),
        r = true;

      for (i=0,ii=categories.length;i<ii;i++) {
        trimmed = $scope.trim(categories[i].name);
        if (trimmedCurrent === trimmed) {
          r = false;
          break;
        }
      }

      return r;

    };

    $scope.done = function() {
      if ($scope.isUnique()) {
        if ($scope.model.name.replace(/\s+/g, '').length > 0) {
          $scope.success();
        }else{
          $scope.errors.push({ message: 'Please enter a valid name'});
        }
      }else{
        $scope.errors.push({ message: 'A price list named "' + $scope.model.name + '" already exists' });
      }
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close($scope.model);
    };

    $scope.init();

}]);